import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { loadInbioContents } from "actions/inbio";
import { getIpAndPublishToSns } from "actions/support";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import InbioProfileContent from "../../components/InbioContentComponents/InbioProfileContent";
import InbioLinkContent from "../../components/InbioContentComponents/InbioLinkContent";
import InbioTextContent from "../../components/InbioContentComponents/InbioTextContent";
import InbioVideoContent from "../../components/InbioContentComponents/InbioVideoContent";
import InbioRewardsLinksAndOWIContent from "../../components/InbioContentComponents/InbioRewardsLinksAndOWIContent";
import InbioNavigation from "../../components/InbioContentComponents/InbioNavigation";
import InbioSocialChannelsContent from "../../components/InbioContentComponents/InbioSocialChannelsContent";
import InbioPoweredByML from "styles/images/inbio-powered-by-ML.svg";
import CommissionableLinks from "styles/images/commissionable-links.svg";

const mapStateToProps = (state) => {
  return {
    pages: state.inbio.pages || [],
    appearance_settings: state.inbio.appearance_settings || {},
    error: state.inbio.error || null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadInbioContents: (campaignId) => {
      dispatch(loadInbioContents(campaignId));
    },
    getIpAndPublishToSns: (...args) => {
      dispatch(getIpAndPublishToSns(...args));
    },
  };
};

const InbioBackground = styled("div")`
  display: block;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: -8px;
  width: 100vw;
  height: 100vh;
  background-image: url(${(props) => props.backgroundImage});
  background-color: ${(props) => props.backgroundColor};
  background-size: cover;
  overflow-x: hidden;
  overflow-y: auto;
`;

const InbioContentContainer = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 672px;
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;
  margin: auto;
`;

function InbioHome(props) {
  const [currentPage, setCurrentPage] = useState(0);
  const [pages, setPages] = useState([]);
  const [backgroundType, setBackgroundType] = useState('color');
  const [backgroundColorContent, setBackgroundColorContent] = useState('#111111');
  const [backgroundImageContent, setBackgroundImageContent] = useState('');

  function handleChangePage(page) {
    setCurrentPage(page);
    setPages(
      pages.map((item) => {
        return {
          ...item,
          name: item.title,
          active: item.id === page.id ? true : false,
        };
      })
    );
  }

  useEffect(() => {
    const campaignId = props.match.params.campaign_id;
    if (campaignId) {
      props.loadInbioContents(campaignId);
    }
  }, []);

  useEffect(() => {
    if (props.pages.length > 0) {
      setCurrentPage(
        props.pages.find((page) => page.display_order === 1) || 
        currentPage
      );

      setPages(
        props.pages
          .filter((page, index) => index <= 1)
          .sort((a, b) => a.display_order - b.display_order)
          .map((item, index) => {
            return {
              ...item,
              name: item.title,
              active: index === 0,
            };
          })
      );
    } else {
      setPages([]);
    }
  }, [props.pages]);

  useEffect(() => {
    if (props.error) {
      props.history.push("/");
    }
  }, [props.error]);

  useEffect(() => {
    if(props.appearance_settings.background_type) {
      setBackgroundType(props.appearance_settings.background_type);
    }
    if(props.appearance_settings.background_color) {
      setBackgroundColorContent(props.appearance_settings.background_color);
    }
    if(props.appearance_settings.background_image) {
      setBackgroundImageContent(props.appearance_settings.background_image);
    }
  }, [props.appearance_settings]);

  return (
    <React.Fragment>
      <InbioBackground
          backgroundImage={backgroundType === 'image' ? backgroundImageContent : ""}
          backgroundColor={backgroundType === 'color' ? backgroundColorContent : ""}
      >
        <InbioContentContainer>
          <InbioNavigation pages={pages} setNavigation={handleChangePage} />
          {currentPage != 0 &&
            currentPage.page_type === "classic" &&
            currentPage.contents.map((content) => {
              if (content.type === "InbioProfile") {
                return (
                  <InbioProfileContent key={content.id} content={content} />
                );
              } else if (content.type === "InbioText") {
                return <InbioTextContent key={content.id} content={content} />;
              } else if (content.type === "InbioLink") {
                return (
                  <InbioLinkContent 
                    key={content.id} 
                    content={content} 
                    getIpAndPublishToSns={props.getIpAndPublishToSns} 
                  />
                );
              } else if (content.type === "InbioVideo") {
                return (
                  <InbioVideoContent 
                    key={content.id} 
                    content={content} 
                    getIpAndPublishToSns={props.getIpAndPublishToSns} 
                  />
                );
              } else if (content.type === "InbioSocialChannel") {
                return (
                  <InbioSocialChannelsContent
                    key={content.id}
                    content={content}
                    getIpAndPublishToSns={props.getIpAndPublishToSns} 
                  />
                );
              }
              return null;
            })}
          {currentPage != 0 && currentPage.page_type === "closet" && (
            <InbioRewardsLinksAndOWIContent
              rewardsLinksAndOWIContent={currentPage.contents}
              getIpAndPublishToSns={props.getIpAndPublishToSns} 
            />
          )}
          <div style={{flexGrow: "1"}} />
          <div
            style={
              {
                margin: "4rem auto 0",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column"
              }
            }
            onClick={() => window.open("https://www.magiclinks.com",
               "_blank")}
          >
            <img src={InbioPoweredByML}/>
            <img 
              src={CommissionableLinks}
              style={
                {
                  margin: ".5rem auto"
                }
              }
            />
          </div>
        </InbioContentContainer>
      </InbioBackground>
    </React.Fragment>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(InbioHome));
